export const API_URL =
  `${process.env.VUE_APP_URI}` || "http://localhost:8181/rest/vue2api";
export const RESERVATION_URL =
  `${process.env.VUE_APP_URI_RESERVATION}` ||
  "http://localhost:8181/merlinrezerwacja";
export const serwis = `${process.env.VUE_APP_DOMAIN}` || "wyspykanaryjskie.pl";
export const panstwo_id =
  `${process.env.VUE_APP_COUNTRY_ID}` || "wyspykanaryjskie";
export const panstwo_kod = `${process.env.VUE_APP_COUNTRY_KOD}` || "CI";
export const locid = `${process.env.VUE_APP_COUNTRY_LOCID}` || "CIL000001";
export const panstwo_nazwa =
  `${process.env.VUE_APP_COUNTRY_NAME}` || "Wyspy Kanaryjskie";
export const panstwo_nazwapl =
  `${process.env.VUE_APP_COUNTRY_NAMEPL}` || "Wyspy Kanaryjskie";
export const defaultContext =
  `${process.env.VUE_APP_DEFAULT_CONTEXT}` || "/wakacje";
export const panstwo_stolica =
  `${process.env.VUE_APP_COUNTRY_CAPITOL}` || "Las Palmas de Gran Canaria";
